
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

function getSchema(mode?: 'signin' | 'signup' | 'forgot') {
  const first = mode === 'signup' ? z.string().min(1, "First name is required") : z.string().optional().or(z.literal(""));
  const last = mode === 'signup' ? z.string().min(1, "Last name is required") : z.string().optional().or(z.literal(""));
  return z.object({
    email: z.string().email("Please enter a valid email address"),
    password: z
      .string()
      .min(6, "Password must be at least 6 characters")
      .optional()
      .or(z.literal("")),
    first_name: first,
    last_name: last,
  });
}

export type AuthFormData = z.infer<ReturnType<typeof getSchema>>;
export type AuthMode = 'signin' | 'signup' | 'forgot';

export function useAuthForm(mode?: AuthMode) {
  return useForm<AuthFormData>({
    resolver: zodResolver(getSchema(mode)),
    defaultValues: {
      email: "",
      password: "",
      first_name: "",
      last_name: "",
    },
  });
}
